<template>
  <div>
    <!-- search input -->
    <div>
      <b-card title="Partner Attempt">
        <b-row class="mb-1">
          <!-- search input -->
          <b-col>
            <section>
              <b-button
                v-b-modal.modal-filter-orders
                variant="outline-primary"
                class="d-flex"
              >
                <feather-icon icon="FilterIcon" />Filter
              </b-button>
            </section>
          </b-col>
          <b-col>
            <b-form-group
              v-if="dataFiltered == true"
              class="d-flex justify-content-center"
            >
              <!-- search input -->
              <div>
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  placeholder="search"
                />
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="dataFiltered === true"
            class="d-flex justify-content-end"
          >
            <xlsx-workbook>
              <xlsx-sheet
                v-for="sheet in sheets"
                :key="sheet.name"
                :collection="sheet.data"
                :sheet-name="sheet.name"
              />
              <xlsx-download>
                <b-button variant="primary" class="d-flex">
                  <feather-icon icon="DownloadCloudIcon" /> Export
                </b-button>
              </xlsx-download>
            </xlsx-workbook>
          </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <span v-if="props.column.field === 'refundedFOP'">
              <span>
                {{
                  paymentOptionId.filter(
                    (f) => f.value == props.row.refundedFOP
                  )[0].text
                }}
              </span>
            </span>
            <span v-else-if="props.column.field === 'refundStatus'">
              <span>
                <b-badge
                  v-if="props.row.refundStatus === 0"
                  pill
                  variant="info"
                  class="text-white"
                >
                  Not Requested
                </b-badge>

                <b-badge
                  v-else-if="props.row.refundStatus === 1"
                  pill
                  variant="warning"
                  class="text-white"
                >
                  Pending
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 2"
                  pill
                  variant="light-success"
                  class="text-white"
                >
                  Submitted
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 3"
                  pill
                  variant="success"
                  class="text-white"
                >
                  Request Approved
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 4"
                  pill
                  variant="light-info"
                  class="text-white"
                >
                  Sent
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 5"
                  pill
                  variant="danger"
                  class="text-white"
                >
                  Request Rejected
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 6"
                  pill
                  variant="primary"
                  class="text-white"
                >
                  Completed
                </b-badge>
                <b-badge
                  v-else-if="props.row.refundStatus === 8"
                  pill
                  variant="light-danger"
                  class="text-white"
                >
                  Cancelled
                </b-badge>
                <b-badge v-else pill variant="info">
                  {{ props.row.refundStatus }}
                </b-badge>
              </span>
            </span>
          </template>
          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <b-row>
          <b-col>
            <b-modal
              id="modal-filter-orders"
              title="Partner Approval Attempt"
              ok-title="Search"
              cancel-variant="outline-secondary"
              size="lg"
              @ok="filterOrders"
            >
              <b-form>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Merchants option"
                      label-for="Merchants"
                    >
                      <v-select
                        multiple
                        v-model="selected"
                        :options="merchants"
                        label="name"
                      >
                        <template #option="option">
                          <span>{{ option.name }}</span>
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col cols="6">
                    <b-form-group
                      label="Payment option"
                      label-for="payment-option"
                    >
                      <b-form-select
                        id="payment-option"
                        v-model="filterFopId"
                        :options="paymentOptionId"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Refunded Date Range"
                      label-for="order-date-range"
                    >
                      <flat-pickr
                        v-model="trxnDateRange"
                        class="form-control"
                        :config="{ mode: 'range', maxDate: 'today' }"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </b-col>
        </b-row>

        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    vSelect,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      merchantIds: "",
      selected: [],
      merchants: [],
      pageLength: 5,
      rangeDate: null,
      trxnDateRange: "",
      trxnStartDate: "",
      trxnEndDate: "",
      filterFopId: 0,
      columns: [
        {
          label: "Requested Date",
          field: "requestedDate",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "FlyGate Order ID",
          field: "flyGateOrderId",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Refund Document Number",
          field: "refundDocumentNumber",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Bank Refund Reference",
          field: "bankRefundReference",
        },
        {
          label: "Refunded FOP",
          field: "refundedFOP",
        },
        {
          label: "Refund Status",
          field: "refundStatus",
        },
        {
          label: "Count Attempt",
          field: "countAttempt",
        },

        {
          label: "Merchant Name",
          field: "merchantName",
        },
      ],
      paymentOptionId: [{ value: 0, text: "--select Payment Option--" }],
      rows: [],
      summary: [],
      sheets: [{ name: "Refund Attempt", data: [] }],
      searchTerm: "",
      url: "",
    };
  },
  created() {
    this.fetchallPaymentOptions();
    this.fetchMerchant();
  },
  methods: {
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.merchants = res.merchants;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptionId.push({
              value: item.paymentOptionId,
              text: item.name,
            });
          });

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      // Api call
      this.isLoading = true;
      axios
        .get(
          `/Order/api/V1.0/Refund/GetDuplicateRefundConfirmationAttempt?merchantId=${this.merchantIds}&refundFOP=${this.filterFopId}&fromRefundedDate=${this.trxnStartDate}&toRefundedDate=${this.trxnEndDate}`
        )
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.confirmations;
          res.confirmations.map((m) => {
            this.sheets[0].data.push({
              "Requested Date": m.requestedDate,
              "Custom Order Code": m.customOrderCode,
              "FlyGate Order ID": m.flyGateOrderId,
              "Refund Reference Code": m.refundReferenceCode,
              "Refund Merchant Request Code": m.refundMerchantRequestCode,
              "Refund Document Number": m.refundDocumentNumber,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Bank Refund Reference": m.bankRefundReference,
              " Refunded FOP": this.paymentOptionId.filter(
                (f) => f.value == m.refundedFOP
              )[0].text,
              "Refund Status":
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
              "Count Attempts": m.countAttempts,
              " Merchant Name": m.merchantName,
            });
          });

          this.isLoading = false;
          this.merchantIds = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.rows = [];
          console.log(res);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.merchantIds = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
